// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__vG8JQ","selected":"Menu_selected__qny8n"};